import React from 'react';
import PropTypes from 'prop-types';
import {
  FDStack, FDBox, FDPaper, FDBodyText, FDIcon, FDHeadlineText, FDVideo, FDDisplayText, FDTitleText, FDEmphasisSurface, FDCallToActionButton,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { ContentWrapper } from './ContentWrapper';

export const MemberTestimonials = ({ handleSubmit }) => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const collection = resource.attr('influencerMemberTestimonialCollection');

  if (!collection) return null;

  const sections = resource.attr('influencerMemberTestimonialCollection').resources().list();

  const TitleComponent = isMobile ? FDHeadlineText : FDDisplayText;

  return (
    <FDBox paddingY={isMobile ? 2 : 3}>
      <FDEmphasisSurface rounded={false}>
        <FDStack direction={'column'} spacing={4} paddingY={8}>
          {/* Title */}
          <ContentWrapper>

            {resource.attr('influencerMemberTestimonialSectionTitle') && (
            <TitleComponent align={'center'} value={resource.attr('influencerMemberTestimonialSectionTitle')} size={'lg'} />
            )}

          </ContentWrapper>
          <FDStack overflow={'auto'} paddingY={1} paddingX={isMobile ? 2 : 4} spacing={4}>
            {sections.map((section) => (
              <FDPaper appearance={'flat'} color={'subtle'} width={isMobile ? '90%' : '675px'} flexShrink={0}>
                <FDStack direction={isMobile ? 'column' : 'row'} height={'100%'}>

                  {/* Video */}
                  {section.withRelationship(fr.relationships.video.name, (rel) => (
                    <FDVideo
                      captionsSrc={'captions'}
                      src={rel.link('related').url()}
                      maxWidth={isMobile ? '100%' : '60%'}
                      objectFit={'cover'}
                    />), () => null)}
                  <FDStack direction={'column'} spacing={4} flex={1} paddingX={2} paddingY={2} justifyContent={'space-between'}>
                    <FDStack direction={'column'} spacing={2}>

                      {/* Verified Facet Member */}
                      <FDStack direction={'row'} spacing={1} alignItems={'center'}>
                        <FDIcon icon={'identityVerified'} color={'textSecondary'} size={'sm'} />
                        <FDTitleText value={section.attr('verifiedDescription')} color={'textSecondary'} />
                      </FDStack>

                      {/* Title and Description */}
                      <FDHeadlineText value={section.attr('title')} />
                      <FDBodyText value={section.attr('description')} />
                    </FDStack>

                    {/* Callout */}
                    <FDPaper appearance={'flat'} color={'info'}>
                      <FDStack padding={1}>
                        <FDBodyText value={section.attr('callout')} />
                      </FDStack>
                    </FDPaper>
                  </FDStack>
                </FDStack>
              </FDPaper>
            ))}

          </FDStack>
          <ContentWrapper>
            {/* Member Disclosure */}
            <FDStack paddingX={isMobile ? 2 : 8}>
              <MetaControlField attr={'influencerMemberTestimonialDisclosure'} align={'center'} />
            </FDStack>

            {/* Get started button */}
            <FDCallToActionButton onClick={handleSubmit} label={resource.attr('primaryActionLabel')} isFullWidth={isMobile} size={'lg'} />
          </ContentWrapper>
        </FDStack>
      </FDEmphasisSurface>
    </FDBox>
  );
};

MemberTestimonials.propTypes = {
  handleSubmit: PropTypes.func,
};
